// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].use[1]!./fonts.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  --primary: #1a5fa8;
  --header: #2A3A42;
}

.Toastify__toast-body {
  font-size: 12px;
  font-family: 'Segoe UI', sans-serif;
}
.Toastify__toast-container.Toastify__toast-container--top-right {
  top: 12px !important;
  right: 12px !important;
  margin-top: 0;
  width: auto;
  max-width: 280px;
}
.Toastify__close-button--default {
  color: #f8f8f8;
  opacity: 1;
}

html,
body {
  width: 100%;
  height: 100%;
  font-size: 62.5%;
  font-family: "Segoe UI" !important;
  margin: 0;
  background: #f8f8f8;
}

.__hero--container--main {
  font-size: 1em;
  margin: 8px 20px 0 20px;
}

.__hero--container--main--breadcrumb {
  font-weight: bolder;
  color: #020a21;
  margin-top: 0.7em;
  margin-left: 1.7em;
  letter-spacing: 0.8px;
  font-size: 1em;
  margin-bottom: 1.1em;
}
.__hero--container--main--title {
  color: #020a21;
  font-weight: bold;
  font-size: 1.6em;
  margin-left: 1em;
}

.MuiAutocomplete-inputRoot {
  height: auto;
}
.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]
  .MuiAutocomplete-endAdornment {
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
  }

.MuiAutocomplete-root .MuiInputLabel-root {
  display: none !important;
}
.MuiAutocomplete-root .MuiOutlinedInput-notchedOutline legend {
  display: none !important;
}
.MuiAutocomplete-root .MuiOutlinedInput-notchedOutline {
  top: 0 !important;
}

.MuiInputLabel-outlined {
  font-size: 14px;
}
.MuiListItemIcon-root {
  min-width: 0 !important;
}
.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] {
  padding: 0 8px !important;
  font-family: "Segoe UI" !important;
}
.MuiFormLabel-root {
  color: darkgrey;
}
.MuiBackdrop-root {
  background-color: transparent !important;
}

.__Login_container {
  font-size: 16px;
}

/*MyTeam Grid*/
#app > div > div.__hero--container--main > div > div.__teamAlerts__grid
  > div.MuiPaper-root.MuiPaper-elevation2.MuiPaper-rounded > div > div > div {
  height: 400px;
}
@media (min-height: 768px) {
  #app > div > div.__hero--container--main > div > div.__teamAlerts__grid
    > div.MuiPaper-root.MuiPaper-elevation2.MuiPaper-rounded > div > div > div {
    height: 695px;
  }
  #app > div.__hero--container--main > div > div.__search__grid
    > div.MuiPaper-root.MuiPaper-elevation2.MuiPaper-rounded > div > div > div {
    width: max-content !important;
  }
}

div[data-bind] div {
  left: 70% !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/styles.css"],"names":[],"mappings":"AAGA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mCAAmC;AACrC;AACA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;AACA;;IAEI,UAAU;IACV,QAAQ;IACR,2BAA2B;EAC7B;;AAEF;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,kCAAkC;AACpC;AACA;EACE,eAAe;AACjB;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA,cAAc;AACd;;EAEE,aAAa;AACf;AACA;EACE;;IAEE,aAAa;EACf;EACA;;IAEE,6BAA6B;EAC/B;AACF;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":["@import \"https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css\";\n@import url(\"./fonts.css\");\n\nhtml {\n  --primary: #1a5fa8;\n  --header: #2A3A42;\n}\n\n.Toastify__toast-body {\n  font-size: 12px;\n  font-family: 'Segoe UI', sans-serif;\n}\n.Toastify__toast-container.Toastify__toast-container--top-right {\n  top: 12px !important;\n  right: 12px !important;\n  margin-top: 0;\n  width: auto;\n  max-width: 280px;\n}\n.Toastify__close-button--default {\n  color: #f8f8f8;\n  opacity: 1;\n}\n\nhtml,\nbody {\n  width: 100%;\n  height: 100%;\n  font-size: 62.5%;\n  font-family: \"Segoe UI\" !important;\n  margin: 0;\n  background: #f8f8f8;\n}\n\n.__hero--container--main {\n  font-size: 1em;\n  margin: 8px 20px 0 20px;\n}\n\n.__hero--container--main--breadcrumb {\n  font-weight: bolder;\n  color: #020a21;\n  margin-top: 0.7em;\n  margin-left: 1.7em;\n  letter-spacing: 0.8px;\n  font-size: 1em;\n  margin-bottom: 1.1em;\n}\n.__hero--container--main--title {\n  color: #020a21;\n  font-weight: bold;\n  font-size: 1.6em;\n  margin-left: 1em;\n}\n\n.MuiAutocomplete-inputRoot {\n  height: auto;\n}\n.MuiAutocomplete-inputRoot[class*=\"MuiOutlinedInput-root\"]\n  .MuiAutocomplete-endAdornment {\n    right: 8px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n.MuiAutocomplete-root .MuiInputLabel-root {\n  display: none !important;\n}\n.MuiAutocomplete-root .MuiOutlinedInput-notchedOutline legend {\n  display: none !important;\n}\n.MuiAutocomplete-root .MuiOutlinedInput-notchedOutline {\n  top: 0 !important;\n}\n\n.MuiInputLabel-outlined {\n  font-size: 14px;\n}\n.MuiListItemIcon-root {\n  min-width: 0 !important;\n}\n.MuiAutocomplete-inputRoot[class*=\"MuiOutlinedInput-root\"] {\n  padding: 0 8px !important;\n  font-family: \"Segoe UI\" !important;\n}\n.MuiFormLabel-root {\n  color: darkgrey;\n}\n.MuiBackdrop-root {\n  background-color: transparent !important;\n}\n\n.__Login_container {\n  font-size: 16px;\n}\n\n/*MyTeam Grid*/\n#app > div > div.__hero--container--main > div > div.__teamAlerts__grid\n  > div.MuiPaper-root.MuiPaper-elevation2.MuiPaper-rounded > div > div > div {\n  height: 400px;\n}\n@media (min-height: 768px) {\n  #app > div > div.__hero--container--main > div > div.__teamAlerts__grid\n    > div.MuiPaper-root.MuiPaper-elevation2.MuiPaper-rounded > div > div > div {\n    height: 695px;\n  }\n  #app > div.__hero--container--main > div > div.__search__grid\n    > div.MuiPaper-root.MuiPaper-elevation2.MuiPaper-rounded > div > div > div {\n    width: max-content !important;\n  }\n}\n\ndiv[data-bind] div {\n  left: 70% !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
